import { render, staticRenderFns } from "./MsRecycleScrollerV2.vue?vue&type=template&id=2a2649fc&scoped=true"
import script from "./MsRecycleScrollerV2.vue?vue&type=script&lang=js"
export * from "./MsRecycleScrollerV2.vue?vue&type=script&lang=js"
import style0 from "./MsRecycleScrollerV2.vue?vue&type=style&index=0&id=2a2649fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2649fc",
  null
  
)

export default component.exports